import Text, { Inline } from 'components/base/Text';
import {
  StyledButtonWrapper,
  StyledSectionWrapper
} from './GitProvidierSelect.style';
import { SectionTitle } from './SectionTitle';
import { ToggleButton, ToggleButtonGroup } from '@linearb/linui-common';
import { ProviderButtonContent } from './ProviderButtonContent';
import { AUTH_METHODS, GIT_PROVIDERS_CONFIG } from '../../consts';
import { Flex } from 'components/base/layout-components';
import { GitProviderSelectContext } from './GitProviderSelect.context';
import { useContext } from 'react';
import { cn, LBButton, LBInput } from '@linearb/buzz';

export function Connect() {
  const {
    isPat,
    pat,
    setPat,
    onConnect,
    apiTestSuccessfully,
    tokenDisabled,
    failurePayload,
    showOrgNameField,
    orgName,
    setOrgName,
    selectedProvider,
    setSelectedProvider,
    selectedMethod,
    setSelectedMethod
  } = useContext(GitProviderSelectContext);

  return (
    <div>
      <Text size='x-x-larger' mb='3.5rem'>
        SETUP YOUR NEW ORGANIZATION
      </Text>
      <StyledSectionWrapper>
        <SectionTitle title='SELECT GIT PROVIDER' />
        <ToggleButtonGroup
          value={selectedProvider}
          onChange={setSelectedProvider}
          multi={false}
        >
          {Object.entries(GIT_PROVIDERS_CONFIG).map(
            ([value, { name, logo }]) => (
              <ToggleButton key={value} value={value}>
                <ProviderButtonContent
                  logo={logo}
                  name={name}
                  isSelected={selectedProvider === value}
                />
              </ToggleButton>
            )
          )}
        </ToggleButtonGroup>
      </StyledSectionWrapper>
      <StyledSectionWrapper>
        <SectionTitle title='SELECT AUTHORIZATION METHOD' />
        <ToggleButtonGroup
          value={selectedMethod}
          onChange={setSelectedMethod}
          multi={false}
        >
          <ToggleButton
            value={AUTH_METHODS.OAUTH}
            disabled={
              !GIT_PROVIDERS_CONFIG[selectedProvider][AUTH_METHODS.OAUTH]
            }
          >
            <Text size='x-medium'>OAuth</Text>
          </ToggleButton>
          <ToggleButton
            value={AUTH_METHODS.PAT}
            disabled={!GIT_PROVIDERS_CONFIG[selectedProvider][AUTH_METHODS.PAT]}
          >
            <Flex direction='column' items='center' justify='center'>
              <Text size='x-medium'>Personal access</Text>
              <Text size='x-medium'>token</Text>
            </Flex>
          </ToggleButton>
        </ToggleButtonGroup>
        {showOrgNameField && isPat && (
          <Flex mt='0.5rem'>
            <LBInput
              className='w-80'
              width='30rem'
              value={orgName}
              onChange={event => setOrgName(event.target.value)}
              placeholder='enter organization name'
              onBlur={() => setOrgName(orgName)}
            />
          </Flex>
        )}
        <Flex mt='0.5rem' invisible={!isPat}>
          <LBInput
            className={cn('w-80', {
              'border-destructive': !!failurePayload
            })}
            value={pat}
            onChange={event => setPat(event.target.value)}
            disabled={tokenDisabled}
            placeholder='Enter personal access token'
          />
        </Flex>
      </StyledSectionWrapper>
      <StyledSectionWrapper mb='2rem'>
        <SectionTitle title='CONNECT YOUR ACCOUNT' />
        <Text size='normal' letterSpacing='0.02rem' lineHeight='140%'>
          When connecting, LinearB will prompt you to choose which repositories
          to scan for insights and metrics. This will show up in the LinearB
          user interface,{' '}
          <Inline weight='700' size='normal'>
            without making any changes
          </Inline>{' '}
          to your repositories.
        </Text>
      </StyledSectionWrapper>
      <Flex diretion='column' position='relative' justify='center' width='100%'>
        <StyledButtonWrapper>
          <LBButton
            size='lg'
            onClick={onConnect}
            disabled={isPat && !apiTestSuccessfully}
          >
            CONNECT
          </LBButton>
        </StyledButtonWrapper>
      </Flex>
    </div>
  );
}
